/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState, useEffect } from "react";
import { MonitorStatus } from "./widget/LiveMonitorWrapper";
import { MONITOR_LIVE_HD_REFRESH_MSEC } from "./widget/constants";
import { MonitorLiveDaMesModel } from "../../../api/live-monitor/models";
import { getMonitorLivePublic } from "../../../api/live-monitor/requests";
import moment from "moment";
import { get } from "lodash";
import { useLocation } from "react-router-dom";
import MonitorSinglePressDaMesHD from "./widget/MonitorSinglePressDaMesHD";

const LiveMonitorHDPublic: FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [data, setData] = useState<MonitorLiveDaMesModel[]>([]);
  const [results, setResults] = useState<MonitorStatus>({
    lastUpdate: undefined,
    loading: false,
  });

  const requestData = () => {
    setResults({ ...results, loading: true });
    getMonitorLivePublic("hd", params.get("t"))
      .then((response) => {
        setResults({
          loading: false,
          lastUpdate: moment().toDate(),
        });
        setData(get(response, "data", []));
      })
      .catch((error) => {
        setResults({ ...results, loading: false });
        console.log(error);
      });
  };

  useEffect(() => {
    const interval = setInterval(
      () => requestData(),
      MONITOR_LIVE_HD_REFRESH_MSEC
    );

    requestData();

    return () => clearInterval(interval);
  }, []); //eslint-disable-line

  return (
    <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
      {/* begin::Content */}
      <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-10">
        <div className="row g-3 gx-xxl-12">
          {data.map((item, idx) => (
            <MonitorSinglePressDaMesHD item={item} key={`monitor-itm-${idx}`} />
          ))}
        </div>
      </div>
      {/* end::Content */}
    </div>
  );
};

export default LiveMonitorHDPublic;
